module.exports = __webpack_public_path__ + "img/realme.a4123f81.png";